<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
        <div>
            <div class>
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item label="价格" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                        <a-input
                                v-model="info.price"
                                placeholder="请输入价格"
                                v-decorator="[
          'price',
          {rules: [{ required: false, message: '请输入价格!' }],initialValue:info.price}
        ]"
                        ></a-input>
                    </a-form-item>

                    <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
                        <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;"/>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-spin>
</template>

<script>
    var that;
    var thisInfo = [];
    export default {
        props: {
            id: Number
        },
        data() {
            return {
                dis: false,
                form: this.$form.createForm(this),
                info: {
                    categoryId: [0],
                    price:0
                },
                treeData: [],
                fileList: [],
                previewVisible: false,
                columnlist: [],
                previewImage: "",
                picArr: [],
                isloading: false,
                loadingTip: "加载中..."
            };
        },
        mounted() {
            this.$nextTick(function () {
                that = this;
            });
        },
        methods: {
            /**取消 */
            cancelClick() {
                this.$emit("callbackMethod");
            },
            handleSubmit(e) {
                e.preventDefault();
                this.$emit("callbackMethod",this.info.price,this.id);
            },
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    }
                });
            }
        }
    };
</script>
<style>
</style>